import { generateEndpoint } from '@ngtrvu/use-api';
import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_IAP_NOTIFICATION_LIST_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_IAP_NOTIFICATION_LIST_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_IAP_NOTIFICATION_LIST_API_ID,
  ({ id, ...params }: { id?: string } & Record<string, any>) => ({
    endpoint: generateEndpoint({
      host: `/api/admin/iap-notifications`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
